import React from 'react';

import { Field, Form } from '~/components/form';
import IncrementorField from '~/components/inputs/incrementor-field';
import { AddToCartError } from '~/components/products/product-detail/add-product-form';
import { Price } from '~/components/sunday-store/components/product-details/product-details-page';
import { useCartMutations } from '~/features/cart/cart-actions';
import { required, valid } from '~/utils/validation';
import Button from '~/components/button';
import { captureException } from '~/utils/exception-tracking';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';
import getChannelAndPrice from '~/utils/get-channel-price';
import { CHANNEL_NON_FUNNEL } from '~/utils/channels';

import styles from '~/components/seed/seed-finder.module.scss';

const SeedProductForm = ({
  productDetails,
  purchaseSku,
  quantity,
  afterSubmit,
  channel,
  onFieldChange,
}) => {
  const { showFlashMessage } = useFlashMessage();
  const { addToCart } = useCartMutations();

  const { fullPrice, unitPrice } = getChannelAndPrice(CHANNEL_NON_FUNNEL, {
    productDetails,
    purchaseSku,
  });

  const isInStock = Boolean(
    productDetails?.inStock === true || productDetails?.inStock === undefined
  );

  const handleSubmit = async (formValues) => {
    try {
      await addToCart(purchaseSku, formValues.quantity);

      if (afterSubmit) {
        afterSubmit(formValues.quantity);
      }
    } catch (err) {
      let errorMessage =
        err.errors ||
        `There was a problem adding ${
          productDetails?.name || 'the product'
        } to your cart`;
      showFlashMessage(errorMessage, 'error');
      captureException(new AddToCartError('Seed Finder Results Page'), {
        extras: {
          error: JSON.stringify(err),
        },
      });
    }

    return null;
  };

  const validate = (formValues) => {
    const errors = {};
    if (formValues.quantity < 1) {
      errors.quantity = valid(required('Please select plan'))(
        formValues.quantity
      );
    }

    return errors;
  };
  return (
    <Form
      className={styles.addProductForm}
      onSubmit={handleSubmit}
      validate={validate}
      initialValues={{ quantity }}
    >
      {({ isSubmitting }) => (
        <>
          <Price
            classname={styles.price}
            channel={channel}
            qtySelected={quantity}
            fullPrice={fullPrice}
            unitPrice={unitPrice}
          />
          {productDetails?.formFactor && (
            <span className={styles.formFactor}>
              {productDetails?.formFactor}
            </span>
          )}

          <div className={styles.incrementorField}>
            <Field
              aria-label="quantity"
              id="quantityMobile"
              name="quantity"
              component={IncrementorField}
              onChange={onFieldChange}
              value={quantity}
              disabled={!isInStock}
            />
          </div>

          <Button
            className={styles.addProductFormButton}
            type="submit"
            variant={isInStock ? 'primary' : 'dark'}
            isLoading={isSubmitting}
            fullWidth
            disabled={purchaseSku?.isRestrictedInState || !isInStock}
          >
            {isInStock ? 'Add to cart' : 'Sold out'}
          </Button>

          {!isInStock && productDetails?.outOfStockMessage && (
            <p className={styles.addProductFormOutOfStock}>
              {productDetails?.outOfStockMessage}
            </p>
          )}
        </>
      )}
    </Form>
  );
};

export default SeedProductForm;
